import { useState, createContext, useMemo, useCallback } from "react";
import { EditContactType } from "../../../types/ClientSpace";

type ContactContextType = {
    contacts: EditContactType[];
} & {
    updateContacts: Function;
};

type ContactsInfosType = Omit<ContactContextType, "updateContacts">;

export const ContactsContext = createContext<ContactContextType>({
    contacts: [],
    updateContacts: (contacts: any) => null,
});

export const ContactsContextProvider = ({ children }: any) => {
    const [contacts, setContacts] = useState<ContactsInfosType>({
        contacts: [],
    });

    const updateContacts = useCallback((contactsInfo: ContactsInfosType) => {
        setContacts(contactsInfo);
    }, []);

    const ContactsInfosWrapperContext = useMemo(
        () => ({
            ...contacts,
            updateContacts,
        }),
        [contacts, updateContacts]
    );

    return (
        <ContactsContext.Provider value={ContactsInfosWrapperContext}>
            {children}
        </ContactsContext.Provider>
    );
};
